import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-amf-navy flex items-center justify-center px-6" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 justify-center mb-8">
          <img src="/board/logo-circle.png" alt="AMF" className="h-12 w-12 rounded-full" />
          <span className="font-playfair text-2xl text-amf-cream">Asana Memorial</span>
        </Link>
        <div className="bg-amf-cream p-8 md:p-10">
          <p className="amf-overline text-amf-burgundy">Admin Access</p>
          <h1 className="font-playfair text-3xl text-amf-navy mt-2 mb-8">Sign in</h1>
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            <div>
              <label className="amf-overline text-amf-stone block mb-2">Email</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full bg-transparent border-0 border-b border-amf-navy/25 rounded-none px-0 py-2.5 font-lora focus:outline-none focus:border-amf-burgundy"
              />
            </div>
            <div>
              <label className="amf-overline text-amf-stone block mb-2">Password</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full bg-transparent border-0 border-b border-amf-navy/25 rounded-none px-0 py-2.5 font-lora focus:outline-none focus:border-amf-burgundy"
              />
            </div>
            {error && (
              <p data-testid="login-error" className="font-inter text-sm text-amf-burgundy">
                {error}
              </p>
            )}
            <button
              type="submit"
              data-testid="login-submit"
              disabled={loading}
              className="w-full font-inter uppercase tracking-[0.18em] text-sm bg-amf-burgundy text-amf-cream py-3.5 hover:bg-[#c24e12] transition-colors disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
